(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-analysis/assets/route-play-analysis.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-analysis/assets/route-play-analysis.js');
"use strict";

const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const useFetchAnalysesByDraw = svs.components.sportinfo.gameAnalysesRedux.hooks.useFetchAnalysesByDraw;
const selectDrawAnalysesShouldShowSkeleton = svs.components.sportinfo.gameAnalysesRedux.selectors.selectDrawAnalysesShouldShowSkeleton;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _React = React,
  useContext = _React.useContext;
const SideNavResize = svs.components.tipsen.sideNavResize.SideNavResize;
const Analyze = svs.components.sportinfo.analyze.Analyze;
const setCouponValues = svs.components.tipsen.engine.actions.setCouponValues;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const selectOutcomesEventTypeId = svs.components.tipsen.engine.selectors.engineSelectors.selectOutcomesEventTypeId;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const RoutePlayAnalysis = _ref => {
  let branding = _ref.branding,
    className = _ref.className;
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId,
    drawNumber = _useContext.drawNumber;
  useFetchAnalysesByDraw(drawNumber, productId);
  const shouldShowSkeleton = useSelector(state => selectDrawAnalysesShouldShowSkeleton(state, productId, drawNumber));
  const dispatch = useDispatch();
  const couponId = useCouponId();
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const draw = useCurrentDraw();
  const sportType = draw.sportType;
  if (shouldShowSkeleton) {
    return 'Hämtar spelanalyser...';
  }
  const setCoupon = signs => {
    dispatch(setCouponValues({
      couponId,
      signs: [{
        signs
      }]
    }));
  };
  return React.createElement(ErrorBoundary, null, React.createElement(SideNavResize, null, React.createElement("div", {
    className: className
  }, React.createElement(Analyze, {
    branding: branding,
    drawNumber: drawNumber,
    eventTypeId: eventTypeId,
    productId: productId,
    setCoupon: setCoupon,
    sportType: sportType
  }))));
};
setGlobal('svs.components.tipsen.routePlayAnalysis.RoutePlayAnalysis', RoutePlayAnalysis);

 })(window);